// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img/wave-pattern.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.boxMain {
  background-color: #07405E;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100dvh;
  background-image: linear-gradient(180deg, rgba(0, 84, 130, 0.87), rgb(0, 47, 72)), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: repeat-x;
  position: relative;
}

.descriptionText {
  animation: continue-appearance 0.8s ease-in-out;
  color: #699BB6;
  font-weight: 600;
  line-height: 140%;
  text-align: center;
  font-family: "Roboto", sans-serif;
  margin-top: -30dvh;
}

.shineBlock {
  position: absolute;
  width: 300px;
  height: 300px;
}
.shineBlock .star-2 {
  background-color: #fff;
  transition: opacity 0.5s ease-in;
}
.shineBlock .shining {
  opacity: 0.5;
}
.shineBlock .cls-1 {
  fill: #bdfdfa;
}
.shineBlock .shine {
  animation: glitter 3s linear infinite;
}
.shineBlock .openChest {
  animation-name: chestBlink;
  min-height: 20px;
  min-width: 20px;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background: rgb(255, 0, 0);
  background: #5f8e8b;
  position: absolute;
  z-index: 3;
  left: 47%;
  right: 40%;
  bottom: 47%;
  animation-duration: 1.1s;
}
.shineBlock .openChest::before {
  content: "";
  position: absolute;
  inset: -1px;
  background: linear-gradient(90deg, #5f8e8b 0%, rgb(0, 134, 244) 35%);
  filter: blur(8px);
}
.shineBlock .star-2 {
  transform-origin: 219.47px 205.7px;
  animation-duration: 1.5s;
  box-shadow: #7dd3fd 10px 10px 0px;
}
@keyframes glitter {
  0% {
    -webkit-transform: scale(5) rotate(0deg);
    opacity: 0;
  }
  50% {
    -webkit-transform: scale(6) rotate(90deg);
    opacity: 0.7;
  }
  100% {
    -webkit-transform: scale(5) rotate(180deg);
    opacity: 0;
  }
}
@keyframes chestBlink {
  0% {
    -webkit-transform: scale(3);
    opacity: 1;
  }
  70% {
    -webkit-transform: scale(10);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(20);
    opacity: 0;
  }
}

.shakingChest {
  animation: chest-shake infinite ease-in-out 0.5s;
}
@keyframes chest-shake {
  0% {
    -webkit-transform: rotate(5deg);
  }
  50% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(5deg);
  }
}
@keyframes continue-appearance {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.boxBody {
  height: 87dvh;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
@media (min-width: 450px) {
  .boxBody {
    width: 400px;
  }
}
@media only screen and (max-height: 712px) {
  .boxBody {
    height: 100%;
  }
}
.boxBody .boxContainer {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100dvh;
  padding: 10px 0px;
}
.boxBody .boxContainer .box {
  width: 150px;
  height: 150px;
  position: relative;
  cursor: pointer;
  z-index: 2;
  background-size: cover;
  background-position: center;
  box-shadow: #5f8e8b 10px;
}
.boxBody .boxContainer .box img {
  width: 100%;
  height: 100%;
}
.boxBody .boxContainer .dropShadow {
  height: 100px;
  width: 100px;
  position: absolute;
  left: 50%;
  margin-left: -50px;
  top: 50%;
  border-radius: 50%;
  background: linear-gradient(90deg, #fffb00 0%, #d5cc1d 35%);
  filter: blur(30px);
}`, "",{"version":3,"sources":["webpack://./src/modules/box/index.scss","webpack://./src/scss/colors.scss","webpack://./src/scss/fonts.scss"],"names":[],"mappings":"AAGA;EACI,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,0HAAA;EACA,2BAAA;EACA,kBAAA;AADJ;;AAKA;EACI,+CAAA;EACA,cCjBa;EDkBb,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iCEjBK;EFkBL,kBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,YAAA;EACA,aAAA;AAFJ;AAGI;EACI,sBAAA;EACA,gCAAA;AADR;AAIM;EACE,YAAA;AAFR;AAIM;EAAO,aAAA;AADb;AAGI;EACI,qCAAA;AADR;AAGM;EACE,0BAAA;EAEA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,wBAAA;AAFR;AAIM;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,oEAAA;EACA,iBAAA;AAFR;AAKM;EACE,kCAAA;EACA,wBAAA;EACA,iCAAA;AAHR;AAMM;EACE;IACE,wCAAA;IACA,UAAA;EAJR;EAMM;IACE,yCAAA;IACA,YAAA;EAJR;EAMM;IACE,0CAAA;IACA,UAAA;EAJR;AACF;AAMI;EACI;IACE,2BAAA;IACA,UAAA;EAJR;EAMM;IACE,4BAAA;IACA,UAAA;EAJR;EAMM;IACE,4BAAA;IACA,UAAA;EAJR;AACF;;AAOU;EACE,gDAAA;AAJZ;AAMY;EACE;IACE,+BAAA;EAJd;EAMY;IACE,+BAAA;EAJd;EAMY;IACE,+BAAA;EAJd;AACF;AAMkB;EACE;IACE,UAAA;EAJpB;EAMkB;IACE,UAAA;EAJpB;EAMkB;IACE,UAAA;EAJpB;AACF;;AAUU;EACI,aAAA;EAOA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;AAbd;AAIc;EAFJ;IAGQ,YAAA;EADhB;AACF;AAEc;EALJ;IAMQ,YAAA;EAChB;AACF;AAIY;EAEI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AAHhB;AAIgB;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,sBAAA;EACA,2BAAA;EACA,wBAAA;AAFpB;AAGoB;EACI,WAAA;EACA,YAAA;AADxB;AAKkB;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;EAEA,kBAAA;EACA,2DAAA;EACA,kBAAA;AAJpB","sourcesContent":["@import '../../scss/colors.scss';\n@import '../../scss/fonts.scss';\n\n.boxMain {\n    background-color: #07405E;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n    height: 100dvh;\n    background-image: linear-gradient(180deg, rgba(0, 84, 130, 0.87), rgba(0, 47, 72, 1)),url('../../assets/img/wave-pattern.png');\n    background-repeat:repeat-x;\n    position: relative;\n     \n}\n\n.descriptionText{\n    animation: continue-appearance 0.8s ease-in-out;\n    color: $color-Secondary;\n    font-weight: 600;\n    line-height: 140%;\n    text-align: center;\n    font-family: $Roboto;\n    margin-top: -30dvh;\n}\n\n.shineBlock{\n    position: absolute;\n    width: 300px;\n    height: 300px;\n    .star-2 {\n        background-color: #fff;\n        transition: opacity 0.5s ease-in;\n      }\n      \n      .shining {\n        opacity: 0.5;\n      }\n      .cls-1{fill:#bdfdfa;}\n    \n    .shine {\n        animation: glitter 3s linear infinite,\n      }\n      .openChest{\n        animation-name: chestBlink ;\n\n        min-height: 20px;\n        min-width: 20px;\n        height: 20px;\n        width: 20px;\n        border-radius: 50%;\n        background: rgb(255,0,0);\n        background: #5f8e8b;\n        position: absolute;\n        z-index: 3;\n        left: 47%;\n        right: 40%;\n        bottom: 47%;\n        animation-duration: 1.1s;\n      }\n      .openChest::before {\n        content: \"\";\n        position: absolute;\n        inset: -1px;\n        background: linear-gradient(90deg,#5f8e8b 0%, rgb(0, 134, 244) 35%);\n        filter: blur(8px); \n      }\n      \n      .star-2 {\n        transform-origin: 219.47px 205.7px;\n        animation-duration: 1.5s;\n        box-shadow: #7dd3fd 10px 10px 0px\n      }\n      \n      @keyframes glitter {\n        0% {\n          -webkit-transform: scale(5) rotate(0deg) ;\n          opacity: 0;\n        }\n        50% {\n          -webkit-transform: scale(6) rotate(90deg);\n          opacity: 0.7;\n        }\n        100% {\n          -webkit-transform: scale(5) rotate(180deg);\n          opacity: 0;\n        }\n    }\n    @keyframes chestBlink {\n        0% {\n          -webkit-transform: scale(3)  ;\n          opacity: 1;\n        }\n        70% {\n          -webkit-transform: scale(10) ;\n          opacity: 1;\n        }\n        100% {\n          -webkit-transform: scale(20) ;\n          opacity: 0;\n        }\n    }\n}\n          .shakingChest{\n            animation: chest-shake  infinite ease-in-out 0.5s;\n\n            @keyframes chest-shake {\n              0% {\n                -webkit-transform: rotate(5deg) ;\n              }\n              50% {\n                -webkit-transform: rotate(0deg) ;\n              }\n              100% {\n                -webkit-transform: rotate(5deg) ;\n              }\n          }\n                  @keyframes continue-appearance {\n                    0% {\n                      opacity: 0;\n                    }\n                    50% {\n                      opacity: 0;\n                    }\n                    100% {\n                      opacity: 1;\n                    }\n                }\n          }\n\n\n        \n          .boxBody{\n              height: 87dvh;\n              @media (min-width: 450px){\n                  width: 400px;\n                }\n              @media only screen and (max-height: 712px) {\n                  height: 100%;\n                }\n              display: flex;\n              align-items: center;\n              flex-direction: column;\n              justify-content: center;\n            .boxContainer{\n          \n                display: flex;\n                align-items: center;\n                flex-direction: column;\n                justify-content: center;\n                width: 100%;\n                height: 100dvh;\n                padding: 10px 0px;\n                .box{\n                    width: 150px;\n                    height: 150px;\n                    position: relative;\n                    cursor: pointer;\n                    z-index: 2;\n                    background-size: cover;\n                    background-position: center;\n                    box-shadow: #5f8e8b 10px ;\n                    img{\n                        width: 100%;\n                        height: 100%;\n                    }\n                  }\n                  \n                  .dropShadow{\n                    height: 100px;\n                    width: 100px;\n                    position: absolute;\n                    left: 50%;\n                    margin-left: -50px;\n                    top: 50%;\n                    // margin-top: 50px;\n                    border-radius: 50%;\n                    background: linear-gradient(90deg,#fffb00 0%, #d5cc1d 35%);\n                    filter: blur(30px); \n                  }\n                }\n          }\n      ","$color-White:#FFFFFF;\n$color-Secondary:#699BB6;\n\n$color-Gradient-1-2:#002F48;\n$color-Gradient-2-2:#FF6B6B;\n$color-Gradient-3-2:#987EE4;\n$color-Gradient-4-2:#F595DF; \n$color-Gradient-5-2:#FEA5A5;\n\n$color-Gradient-1-1:#216B93;\n$color-Gradient-2-1:#F595DF;\n$color-Gradient-3-1:#6D4ECB;\n$color-Gradient-4-1:#C465AE;\n\n","@import url('https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap');\n$Bitter: 'Bitter', serif;   \n$Crimson-Pro: 'Crimson Pro', serif;\n$Alfa-Slab-One: 'Alfa Slab One', serif;\n$Noto-Serif: 'Noto Serif', serif;\n$Roboto: 'Roboto', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
